import { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';
import { subscribeToBroadcast } from '../lib/broadcast';

export function useOnboardingSync() {
  const { user, setUser, onboardingStep, setOnboardingStep } = useAuthStore();

  useEffect(() => {
    // Subscribe to broadcast channel updates
    const unsubscribe = subscribeToBroadcast((data) => {
      if (data.user) {
        setUser(data.user);
      }
      if (data.onboardingStep !== undefined) {
        setOnboardingStep(data.onboardingStep);
      }
    });

    // Handle page visibility changes
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && user?.id) {
        // Refresh user data when tab becomes visible
        useAuthStore.getState().subscribeToProfile()();
      }
    };

    // Handle storage changes
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'auth-storage' && e.newValue) {
        try {
          const newState = JSON.parse(e.newValue);
          if (newState.state.user) {
            setUser(newState.state.user);
          }
          if (newState.state.onboardingStep !== undefined) {
            setOnboardingStep(newState.state.onboardingStep);
          }
        } catch (error) {
          console.error('Failed to parse storage update:', error);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('storage', handleStorageChange);

    return () => {
      unsubscribe();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('storage', handleStorageChange);
    };
  }, [user?.id, setUser, setOnboardingStep]);
}